import React, { Component } from "react";
import ParkingForm from "../../../forms/ParkingForm";
import {
  createParking,
  getParking,
  syncParkingStickers,
  updateParking
} from "../../../../services/api/parkings";
import { ajaxErrorHandler, defaultSuccess } from "../../../../libs/utils";
import { withRouter } from "react-router-dom";

class ParkingsCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      parkingCreating: false,
      parking: undefined,
      submitting: false
    };

    this._handleSubmit = this._handleSubmit.bind(this);
  }

  UNSAFE_componentWillMount() {
    const parkingId = this.props.match.params.parkingId;

    if (parkingId) {
      getParking(this.props.event.id, parkingId)
        .then(response => {
          this.setState({
            loading: false,
            parking: response
          });
        })
        .catch(e => {
          this.setState({
            loading: false,
            parking: null
          });
        });
    } else {
      this.setState({
        loading: false
      });
    }
  }

  _handleSubmit(values) {
    this.setState({
      submitting: true
    });
    const eventId = this.props.event.id;
    const parking = {
      name: values.name,
      capacity: values.capacity
    };

    if (values.id && values.id !== "") {
      updateParking(eventId, values.id, parking)
        .then(response => this._syncStickers(values.id, values))
        .catch(ajaxErrorHandler);
    } else {
      createParking(eventId, parking)
        .then(response => this._syncStickers(response.id, values))
        .catch(ajaxErrorHandler);
    }
  }

  _syncStickers(parkingId, { stickers, id }) {
    const formatedStickers = stickers.map(sticker => {
      const daysArray = [];

      while (sticker.start < sticker.end) {
        daysArray.push(sticker.start.format("YYYY-MM-DD"));
        sticker.start.add(1, "day");
      }

      return {
        id: sticker.id,
        name: sticker.name,
        quantity: parseInt(sticker.quantity, 10),
        days: daysArray
      };
    });

    syncParkingStickers(this.props.event.id, parkingId, {
      stickers: formatedStickers
    })
      .catch(ajaxErrorHandler)
      .then(() => {
        this.setState({
          submitting: false
        });

        if (id) {
          defaultSuccess("Parking Was Updated");
        } else {
          defaultSuccess("Parking Was Created");
        }

        this.props.history.push(`/admin/events/${this.props.event.id}/parking`);
      });
  }

  render() {
    const { loading, submitting, parking } = this.state;
    const { event } = this.props;

    if (loading) {
      return "loading";
    }

    if (parking === null) {
      return "error loading parking";
    }

    return (
      <div>
        <ParkingForm
          onSubmit={this._handleSubmit}
          isCreating={submitting}
          parking={parking}
          event={event}
        />
      </div>
    );
  }
}

export default withRouter(ParkingsCreate);
